document.addEventListener('DOMContentLoaded', (event) => {
    const collectionHandleElement = document.querySelector('[data-collection-handle]');
    if (collectionHandleElement && collectionHandleElement.getAttribute('data-collection-handle') === '湘南ビール') {
        const quantityInput = document.querySelector('.quantity-input');
        if (quantityInput) {
            quantityInput.setAttribute('disabled', 'disabled');
            quantityInput.value = 1;  // 数量を1に固定
        }
    }
});
